import React, { useContext } from 'react';
import moment from 'moment';
import 'react-date-range/dist/styles.css';
import 'react-date-range/dist/theme/default.css';
import { DateRange } from 'react-date-range';
import {
  SideNav,
  SideNavContainer,
  TransactionsNav,
  NavText,
  NavItem,
  TranscationLogo,
  FiltersContainer,
  FilterBox,
  FilterHeader,
  FilterTitle,
  FilterIcon,
  FilterBody,
  FilterOption,
  CheckboxContainer,
  ButtonItem,
  ButtonContainer,
  ResetContainer,
  CloseButton,
} from '@app/modules/transactions/transactions-components';
import { Checkbox, Button, Icon } from '@app/components';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
  faFilter,
  faTasks,
  IconDefinition as FaIcon,
} from '@fortawesome/free-solid-svg-icons';
import { useLocation } from '@app/utils';
import { TransactionFilters } from '@app/types';
import { useGetUserMunicipalitiesQuery } from '@app/graphql';
import { AuthContext } from '@app/providers';
const statuses = [
  {
    label: 'Open',
    value: 'OPEN',
  },
  {
    label: 'In progress',
    value: 'INPROGRESS',
  },
];

type FilterProps = {
  title: string;
  icon?: FaIcon;
  isOpened: boolean;
  children: any;
  onClick: () => void;
};

type DateRangeProps = {
  startDate: Date;
  endDate: Date;
  key: string;
}[];

type Props = {
  applyFilters: (filters: TransactionFilters) => void;
  resetFilters: (filters: TransactionFilters) => void;
  filters: TransactionFilters;
  isListLoading: boolean;
  closeSideNav?: (e: any) => void;
};

const TransactionFilter = (props: FilterProps) => {
  const { title, children, icon, isOpened, onClick } = props;

  return (
    <FilterBox>
      <FilterHeader onClick={onClick}>
        <FilterTitle>{title}</FilterTitle>
        {icon && (
          <FilterIcon>
            <FontAwesomeIcon icon={icon} />
          </FilterIcon>
        )}
      </FilterHeader>
      <FilterBody isOpened={isOpened}>{children}</FilterBody>
    </FilterBox>
  );
};

const TransactionSidenav = (props: Props) => {
  const { location, navigate } = useLocation();
  const { userInfo }: any = useContext(AuthContext);
  const [municipalities, setMunicipalities] = React.useState<any[]>([]);

  const { loading, data } = useGetUserMunicipalitiesQuery({
    firebaseId: userInfo ? userInfo.id : '',
  });

  const [activeFilter, setActiveFilter] = React.useState<string>(
    'municipalities',
  );
  const [filters, setFilters] = React.useState<TransactionFilters>(
    props.filters,
  );
  const [disabledApplyFilters, setDisabledApplyFilters] = React.useState<
    boolean
  >(true);
  const [disabledResetFilters, setDisabledResetFilters] = React.useState<
    boolean
  >(true);
  const [createdDateRange, setCreatedDateRange] = React.useState<
    DateRangeProps
  >([
    {
      startDate: new Date(filters.createdDateRange.startDate),
      endDate: new Date(filters.createdDateRange.endDate),
      key: 'selection',
    },
  ]);

  React.useEffect(() => {
    if (
      !loading &&
      data.getUserMunicipalityList &&
      data.getUserMunicipalityList.success
    ) {
      const {
        getUserMunicipalityList: { municipality },
      } = data;
      let Municipalities: any[] = [];
      Municipalities = municipality.map((data: any) => {
        return {
          label: data.municipalityName,
          value: data.municipalityId,
        };
      });
      setMunicipalities(Municipalities);
    }
  }, [loading, data]);

  const applyFilters = () => {
    props.applyFilters(filters);
    setDisabledApplyFilters(true);
  };

  const resetFilters = () => {
    const filtersTemp = {
      municipalities: '',
      createdDateRange: {
        startDate: '',
        endDate: '',
      },
      status: '',
    };
    const date = new Date();
    date.setMonth(date.getMonth() - 1);
    setCreatedDateRange([
      {
        startDate: date,
        endDate: new Date(),
        key: 'selection',
      },
    ]);
    setFilters(filtersTemp);
    props.resetFilters(filtersTemp);
    setDisabledApplyFilters(true);
    setDisabledResetFilters(true);
  };

  const handleMunicipalityFilter = (event: any) => {
    const value: string = event.target.value;
    let { municipalities = '' } = filters;
    const municipalityArray = municipalities
      ? municipalities.split('_ARRAY_SPLIT_')
      : [];
    const findIndex = municipalityArray.indexOf(value);
    if (findIndex === -1) {
      municipalityArray.push(value);
    } else {
      municipalityArray.splice(findIndex, 1);
    }
    municipalities = municipalityArray.join('_ARRAY_SPLIT_');
    setFilters({
      ...filters,
      municipalities: municipalities,
    });
    setDisabledApplyFilters(municipalities.length ? false : true);
    setDisabledResetFilters(municipalities.length ? false : true);
  };

  const handleStatusFilter = (event: any) => {
    const value: string = event.target.value;
    let { status = '' } = filters;
    const statusArray = status ? status.split('_ARRAY_SPLIT_') : [];
    const findIndex = statusArray.indexOf(value);
    if (findIndex === -1) {
      statusArray.push(value);
    } else {
      statusArray.splice(findIndex, 1);
    }
    status = statusArray.join('_ARRAY_SPLIT_');
    setFilters({
      ...filters,
      status: status,
    });
    setDisabledApplyFilters(status.length ? false : true);
    setDisabledResetFilters(status.length ? false : true);
  };

  const handleCreatedDateRange = React.useCallback(
    (item: any) => {
      const updatedDateRange = [item.selection];
      setCreatedDateRange(updatedDateRange);
      const [{ startDate, endDate }] = updatedDateRange;
      setFilters({
        ...filters,
        createdDateRange: {
          startDate: moment(startDate).format('YYYY-MM-DD'),
          endDate: moment(endDate).format('YYYY-MM-DD'),
        },
      });
      setDisabledApplyFilters(false);
      setDisabledResetFilters(false);
    },
    [filters],
  );

  const toggleFilter = (filter: string) => {
    setActiveFilter(!activeFilter || activeFilter !== filter ? filter : '');
  };
  type RouteProps = {
    title: string;
    key: string;
    iconName: string;
    path: string;
    type: string;
  };
  const routes: RouteProps[] = [
    {
      title: 'Current Transactions',
      key: 'current_transactions',
      iconName: 'current_transaction',
      path: '/transactions',
      type: 'current',
    },
    {
      title: 'Approved Transactions',
      key: 'approved_transactions',
      iconName: 'completed_transaction',
      path: '/transactions/approved',
      type: 'approved',
    },
    {
      title: 'Documents',
      key: 'documents',
      iconName: 'current_transaction',
      path: '/transactions/documents',
      type: 'documents',
    },
  ];

  const getActivePage = (pageDetails: RouteProps) => {
    if (pageDetails) {
      return pageDetails.type === 'current'
        ? !location.pathname.includes('/transactions/approved') &&
            !location.pathname.includes('/transactions/documents')
        : pageDetails.type === 'documents'
        ? location.pathname.includes('/transactions/documents')
        : location.pathname.includes('/transactions/approved');
    }
    return false;
  };
  return (
    <>
      <SideNav>
        <SideNavContainer>
          <TransactionsNav>
            <div>
              {routes.map((route: RouteProps, index: number) => {
                return (
                  <NavItem
                    key={index}
                    active={getActivePage(route)}
                    onClick={() => navigate(route.path)}>
                    <TranscationLogo active={getActivePage(route)}>
                      <Icon
                        name={
                          route.type === 'current' || route.type === 'documents'
                            ? 'current_transaction'
                            : 'completed_transaction'
                        }
                      />
                    </TranscationLogo>
                    <NavText active={getActivePage(route)}>
                      {route.title}
                    </NavText>
                  </NavItem>
                );
              })}
            </div>
            <CloseButton onClick={props.closeSideNav}>
              <Icon name="close" />
            </CloseButton>
          </TransactionsNav>

          <FiltersContainer>
            {userInfo.userType &&
              userInfo.userType.toLowerCase() !== 'municipality_user' && (
                <TransactionFilter
                  title="Municipalities"
                  icon={faFilter}
                  isOpened={activeFilter === 'municipalities'}
                  onClick={() => {
                    toggleFilter('municipalities');
                  }}>
                  {municipalities.map((data, i) => {
                    return (
                      <FilterOption key={i}>
                        <CheckboxContainer key={i}>
                          <Checkbox
                            label={data.label}
                            size="default"
                            value={data.value}
                            checked={filters.municipalities.includes(
                              data.value,
                            )}
                            onChange={handleMunicipalityFilter}
                          />
                        </CheckboxContainer>
                      </FilterOption>
                    );
                  })}
                </TransactionFilter>
              )}

            <FilterBox>
              <FilterHeader
                onClick={() => {
                  toggleFilter('created_date_range');
                }}>
                <FilterTitle>Created Date Range</FilterTitle>

                <FilterIcon>
                  <Icon name="calender" />
                </FilterIcon>
              </FilterHeader>
              <FilterBody isOpened={activeFilter === 'created_date_range'}>
                <DateRange
                  onChange={handleCreatedDateRange}
                  ranges={createdDateRange}
                  rangeColors={['#17335a']}
                />
              </FilterBody>
            </FilterBox>

            {!location.pathname.includes('/transactions/approved') ? (
              <TransactionFilter
                title="Status"
                icon={faTasks}
                isOpened={activeFilter === 'status'}
                onClick={() => {
                  toggleFilter('status');
                }}>
                {statuses.map((status, i) => {
                  return (
                    <FilterOption key={i}>
                      <CheckboxContainer>
                        <Checkbox
                          label={status.label}
                          size="default"
                          checked={filters.status.includes(status.value)}
                          value={status.value}
                          onChange={handleStatusFilter}
                        />
                      </CheckboxContainer>
                    </FilterOption>
                  );
                })}
              </TransactionFilter>
            ) : (
              ''
            )}
            <ButtonItem>
              {!disabledResetFilters && (
                <ResetContainer disabled={disabledResetFilters}>
                  <Button
                    variant="secondary"
                    size="medium"
                    width="100%"
                    type="submit"
                    onClick={resetFilters}>
                    Reset Filter
                  </Button>
                </ResetContainer>
              )}
              {!disabledApplyFilters && (
                <ButtonContainer disabled={disabledApplyFilters}>
                  <Button
                    variant="primary"
                    size="medium"
                    width="100%"
                    type="submit"
                    onClick={applyFilters}>
                    Apply Filter
                  </Button>
                </ButtonContainer>
              )}
            </ButtonItem>
          </FiltersContainer>
        </SideNavContainer>
      </SideNav>
    </>
  );
};

export default TransactionSidenav;
